import React from "react";

const Footer = () => {
  return <div>Created By: @biGdoG</div>;
};

export default Footer;
